import { ChangeEvent, useState } from "react";
import { classNames } from "@ct-react/core";
import "./switch.scss";

type Props = {
  className?: string;
  active?: boolean;
  onChange?: (value: boolean) => void;
}

const Switch = (
  {
    className,
    active: externalActive,
    onChange: externalOnChange
  }: Props) => {

  const [ uncontrolledActive, setUncontrolledActive ] = useState<boolean>();
  const active = externalActive ?? uncontrolledActive;
  const onChange = externalOnChange ?? setUncontrolledActive;

  const onToggle = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked);

  const wrapperClasses = classNames("switch", className);

  return (
    <div className={wrapperClasses}>
      <input type="checkbox" id="toggle"
             checked={active} onChange={onToggle} />
      <label htmlFor="toggle" className="knob" />
    </div>);

};

export default Switch;
